import React, { useEffect, useState } from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import usePrev from '../../hooks/usePrev';
import { Tooltip } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { formatTime } from '../../utils/utils';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      margin: theme.spacing(1),
      minWidth: 124,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
  }),
);

const specialEventTimes = [
  '',
  '18:00 ',
  '18:30 ',
  '19:00 ',
  '19:30 ',
  '20:00 ',
  '20:30 ',
  '21:00 ',
  '21:30 ',
  '22:00 ',
  '22:30 ',
  '23:00 ',
  '23:30 ',
];

interface TPIProps {
  tName: string;
  disabled: boolean;
  time: string;
  timeName: string;
  setEdited: (edited: boolean) => void;
  setOperationHour: (operationHour: {
    hourName: string;
    hourValue: string;
    isPreviousDay?: string;
  }) => void;
  hasCheckboxes?: boolean;
  enableDhTime24hr?: boolean;
  isDropDownDisabled?: boolean;
  times: string[];
  tooltip?: string;
  hasEditPermission?: boolean;
}
export default function NativeSelects({
  tName,
  disabled,
  time,
  timeName,
  setEdited,
  setOperationHour,
  hasCheckboxes,
  enableDhTime24hr,
  isDropDownDisabled,
  times,
  tooltip = '',
  hasEditPermission = true,
}: TPIProps) {
  const classes = useStyles();
  const { t } = useTranslation();
  const Open = t('operationHours.start');
  const Close = t('operationHours.finish');

  const { deliveryHours } = useSelector(
    (state: RootStateOrAny) => state.NewOperationHoursReducer,
  );

  const [state, setState] = React.useState<{
    time: string | number;
    name: string;
  }>({
    time: '',
    name: '',
  });

  const dispatch: any = useDispatch();
  const {
    drIsOpened24Hours,
    drIsClosed,
    dtIsClosed,
    dtIsOpened24Hours,
    digitalDtIsClosed,
    digitalDtIsOpened24Hours,
    cateringIsClosed,
    curbsideIsClosed,
    dhIsClosed,
    dhIsOpened24Hours = 'N',
    isCalculated,
    isPreviousDay,
  } = useSelector(
    (state: RootStateOrAny) => state.OperationHoursReducer.entity,
  );
  const [isChecked, setIsChecked] = useState(false);
  const brand = useSelector(
    (state: RootStateOrAny) => state.UIReducer.selectedBrand,
  );

  const { Region, Country, CountryId, RestaurantId } = useSelector(
    (state: RootStateOrAny) => state.RestaurantsReducer.entity,
  );

  let availableTimes;

  switch (timeName) {
    case 'arrivalTime':
      availableTimes = [...specialEventTimes, ...times];
      break;
    case 'departureTime':
      availableTimes = [...specialEventTimes, ...times];
      break;
    default:
      availableTimes = times;
      break;
  }

  useEffect(() => {
    if (
      (timeName === 'dtTimeOpen' ||
        timeName === 'dtTimeClose' ||
        timeName === 'digitalDtTimeOpen' ||
        timeName === 'digitalDtTimeClose' ||
        timeName === 'drTimeOpen' ||
        timeName === 'drTimeClose' ||
        timeName === 'deliveryTimeOpen' ||
        timeName === 'deliveryTimeClose' ||
        timeName === 'cateringTimeOpen' ||
        timeName === 'cateringTimeClose' ||
        timeName === 'curbsideTimeOpen' ||
        timeName === 'curbsideTimeClose') &&
      (drIsClosed === 'Y' ||
        drIsOpened24Hours === 'Y' ||
        dtIsClosed === 'Y' ||
        dtIsOpened24Hours === 'Y' ||
        digitalDtIsClosed === 'Y' ||
        digitalDtIsOpened24Hours === 'Y' ||
        dhIsOpened24Hours === 'Y' ||
        cateringIsClosed === 'Y' ||
        curbsideIsClosed === 'Y' ||
        dhIsClosed === 'Y')
    ) {
      setIsChecked(true);
    }
  }, [
    drIsClosed,
    drIsOpened24Hours,
    dtIsClosed,
    dtIsOpened24Hours,
    digitalDtIsClosed,
    digitalDtIsOpened24Hours,
    dhIsOpened24Hours,
    cateringIsClosed,
    curbsideIsClosed,
    dhIsClosed,
  ]);

  const { is12HFormat } = useSelector(
    (state: RootStateOrAny) => state.NewOperationHoursReducer,
  );

  const handleChange = (
    event: React.ChangeEvent<{ name?: string; value: unknown }>,
  ) => {
    const name = event.target.name as keyof typeof state;

    dispatch(setEdited(true));
    setState({
      ...state,
      [name]: event.target.value,
    });

    if (timeName === 'arrivalTime') {
      let isPreviousDay = 'N';
      const selectedIndex = (event.target as HTMLSelectElement).selectedIndex;
      if (selectedIndex <= 12) {
        isPreviousDay = 'Y';
      }
      dispatch(
        setOperationHour({
          hourName: timeName,
          hourValue: String(event.target.value),
          isPreviousDay: isPreviousDay,
        }),
      );
    } else {
      dispatch(
        setOperationHour({
          hourName: timeName,
          hourValue: String(event.target.value),
        }),
      );
    }
  };

  let value =
    timeName === 'arrivalTime' && isPreviousDay === 'Y'
      ? time
      : time.substring(0, 5);

  if (disabled && hasCheckboxes) {
    if (tName === Open) {
      if (
        (timeName === 'dtTimeOpen' && dtIsClosed === 'Y') ||
        (timeName === 'digitalDtTimeOpen' && digitalDtIsClosed === 'Y') ||
        (timeName === 'drTimeOpen' && drIsClosed === 'Y') ||
        (timeName === 'deliveryTimeOpen' && dhIsClosed === 'Y') ||
        (timeName === 'cateringTimeOpen' && cateringIsClosed === 'Y') ||
        (timeName === 'curbsideTimeOpen' && curbsideIsClosed === 'Y')
      ) {
        value = '';
      } else if (
        (timeName === 'dtTimeOpen' && dtIsOpened24Hours === 'Y') ||
        (timeName === 'digitalDtTimeOpen' &&
          digitalDtIsOpened24Hours === 'Y') ||
        (timeName === 'drTimeOpen' && drIsOpened24Hours === 'Y') ||
        (timeName === 'deliveryTimeOpen' && dhIsOpened24Hours === 'Y')
      ) {
        value = '00:00';
      }
    }

    if (tName === Close) {
      if (
        (timeName === 'dtTimeClose' && dtIsClosed === 'Y') ||
        (timeName === 'digitalDtTimeClose' && digitalDtIsClosed === 'Y') ||
        (timeName === 'drTimeClose' && drIsClosed === 'Y') ||
        (timeName === 'deliveryTimeClose' && dhIsClosed === 'Y') ||
        (timeName === 'cateringTimeClose' && cateringIsClosed === 'Y') ||
        (timeName === 'curbsideTimeClose' && curbsideIsClosed === 'Y')
      ) {
        value = '';
      } else if (
        (timeName === 'dtTimeClose' && dtIsOpened24Hours === 'Y') ||
        (timeName === 'digitalDtTimeClose' &&
          digitalDtIsOpened24Hours === 'Y') ||
        (timeName === 'drTimeClose' && drIsOpened24Hours === 'Y') ||
        (timeName === 'deliveryTimeClose' && dhIsOpened24Hours === 'Y')
      ) {
        value = '23:59';
      }
    }
  }

  if (
    isCalculated === 'Y' &&
    dhIsClosed !== 'Y' &&
    (timeName === 'deliveryTimeOpen' || timeName === 'deliveryTimeClose')
  ) {
    if (tName === Open) {
      if (dtIsClosed === 'Y' && drIsClosed === 'Y' && dhIsClosed === 'Y') {
        value = '';
      } else if (dtIsOpened24Hours === 'Y' || drIsOpened24Hours === 'Y') {
        if (deliveryHours.default24HourTimeOpen) {
          value = deliveryHours.default24HourTimeOpen;
        } else {
          value = '00:00';
        }
      }
    }

    if (tName === Close) {
      if (dtIsClosed === 'Y' && drIsClosed === 'Y' && dhIsClosed === 'Y') {
        value = '';
      } else if (dtIsOpened24Hours === 'Y' || drIsOpened24Hours === 'Y') {
        if (deliveryHours.default24HourTimeClose) {
          value = deliveryHours.default24HourTimeClose;
        } else {
          value = '23:59';
        }
      }
    }
  }

  const wasDisabled = usePrev(disabled);
  useEffect(() => {
    if (wasDisabled && hasCheckboxes) {
      dispatch(
        setOperationHour({
          hourName: timeName,
          hourValue: '',
        }),
      );
    }
  }, [dispatch, setOperationHour, timeName, wasDisabled, hasCheckboxes]);

  useEffect(() => {
    if (
      disabled &&
      isChecked &&
      timeName !== 'deliveryTimeOpen' &&
      timeName !== 'deliveryTimeClose'
    ) {
      if (tName === Open) {
        dispatch(
          setOperationHour({
            hourName: timeName,
            hourValue: '00:00',
          }),
        );
      }
      if (tName === Close) {
        dispatch(
          setOperationHour({
            hourName: timeName,
            hourValue: '23:59',
          }),
        );
      }
    }
  }, [disabled, tName, timeName, isChecked]);

  if (
    timeName === 'arrivalTime' &&
    isPreviousDay === 'Y' &&
    value &&
    value != ''
  ) {
    value = `${value} `;
  }

  let deliveryNotExist = false;
  if (
    (timeName === 'deliveryTimeOpen' || timeName === 'deliveryTimeClose') &&
    !availableTimes.find(elem => elem === value)
  ) {
    deliveryNotExist = true;
  }

  const isEnabled =
    isCalculated === 'N' &&
    (timeName === 'deliveryTimeOpen' || timeName === 'deliveryTimeClose') &&
    dhIsOpened24Hours === 'N' &&
    dhIsClosed === 'N';
  const isDisabled = hasEditPermission
    ? isEnabled
      ? !isEnabled
      : isDropDownDisabled || disabled
    : true;

  return (
    <div>
      <Tooltip title={tooltip}>
        <FormControl variant="outlined" className={classes.formControl}>
          <InputLabel htmlFor="outlined-time-native-simple">{tName}</InputLabel>
          <Select
            style={
              isDisabled ? { pointerEvents: 'none', color: 'grey' } : undefined
            }
            native
            value={value}
            onChange={handleChange}
            label={tName}
            inputProps={{
              name: 'time',
              id: 'outlined-time-native-simple',
            }}
            disabled={isDisabled}
          >
            {isCalculated === 'Y' &&
            (timeName === 'deliveryTimeOpen' ||
              timeName === 'deliveryTimeClose') ? (
              <option value={value}>{formatTime(value, is12HFormat)}</option>
            ) : (timeName === 'dtTimeClose' && dtIsOpened24Hours === 'Y') ||
              (timeName === 'digitalDtTimeClose' &&
                digitalDtIsOpened24Hours === 'Y') ||
              (timeName === 'drTimeClose' && drIsOpened24Hours === 'Y') ||
              (timeName === 'deliveryTimeClose' && dhIsOpened24Hours === 'Y') ||
              (timeName === 'dtTimeClose' && dtIsClosed === 'Y') ||
              (timeName === 'digitalDtTimeClose' &&
                digitalDtIsClosed === 'Y') ||
              (timeName === 'drTimeClose' && drIsClosed === 'Y') ? (
              [...availableTimes].map((e, i) => (
                <option key={i} value={e}>
                  {formatTime(e, is12HFormat)}
                </option>
              ))
            ) : (
              [...availableTimes]?.map((e, i) => (
                <option key={i} value={e}>
                  {formatTime(e, is12HFormat)}
                </option>
              ))
            )}
            <option key={'23:59'} value={'23:59'} hidden={true}>
              {formatTime('23:59', is12HFormat)}
            </option>
          </Select>
        </FormControl>
      </Tooltip>
    </div>
  );
}
